import {CartViewUI} from './CartViewUI';
import {useEffectiveEquivalenceCharges} from '../../../user/application/useEffectiveEquivalenceCharges';
import {useCartContext} from '../../context/CartContext';
import {useEffect} from 'react';

export const CartView = () => {
  const { cart, loadCart, equivalenceChargedProducts, equivalenceChargeFreeProducts, loading } = useCartContext();
  const equivalenceCharges = useEffectiveEquivalenceCharges();

  useEffect(() => {
    loadCart();
  }, [loadCart]);

  return (
    <CartViewUI equivalenceChargedProducts={equivalenceChargedProducts}
                equivalenceChargeFreeProducts={equivalenceChargeFreeProducts}
                deprecatedProducts={cart?.deprecatedProducts}
                equivalenceCharges={equivalenceCharges}
                loading={loading}
    />
  );
};